import { Input as AntdInput, Form, Typography } from "antd";
import React, { useState } from "react";
import { config } from "../../config";
import LabelAndValue from "../../form/LabelAndValue";
import useInstantFocus from "../hooks/useInstantFocus";

function HInput(props) {
  const [hasError, setHasError] = useState(false);
  const { Text } = Typography;
  const {
    autoFocus,
    type = "",
    formItemName,
    formItemLabel,
    required,
    errorMessage,
    validator,
    size = "s",
    formItemRules = required
      ? [
          {
            required: true,
            validator: validator
              ? validator
              : (_, value) => {
                  if (!value) {
                    setHasError(true);
                    return Promise.reject(new Error(errorMessage ?? "Required"));
                  } else {
                    setHasError(false);
                    return Promise.resolve();
                  }
                },
          },
        ]
      : [],
    formClassName = "",
    customClasses = "",
    value,
    name = "",
    prefix = null,
    inputHelper,
    placeholder,
    tabIndex = -1,
  } = props;

  const inputConfiguration = config.input ?? {};
  const inputConfigurationBySize = config.input.size[size] ?? {};
  const inputHelperConfigurationBySize = config.text.size[inputHelper?.size];
  const inputHelperConfigurationByType = config.text.type[inputHelper?.type];

  const inputRef = useInstantFocus(autoFocus);

  return (
    <LabelAndValue label={formItemLabel} hasError={hasError}>
      <Form.Item rules={formItemRules} name={formItemName} className={`mb-0 ${formClassName}`}>
        <AntdInput
          {...props}
          name={name}
          value={value}
          ref={inputRef}
          placeholder={placeholder}
          autoComplete="off"
          tabIndex={tabIndex}
          className={`${inputConfigurationBySize?.customClasses ?? ""} ${type === "search" ? "hs-search-input" : inputConfiguration?.customClasses} ${customClasses} ${
            hasError ? "hs-input-has-error" : ""
          }`}
          prefix={prefix}
        />
      </Form.Item>
      {inputHelper && (
        <Text className={`${inputHelperConfigurationBySize?.customClasses ?? ""} ${inputHelperConfigurationByType?.customClasses ?? ""}`}>
          {inputHelper?.text}
        </Text>
      )}
    </LabelAndValue>
  );
}

export default React.memo(HInput);
